function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.961 24.269h13.388V67H3.961Zm14.348-13.6A7.655 7.655 0 1 1 10.655 3a7.66 7.66 0 0 1 7.654 7.667Zm48.674 32.017V67h-13.16V44.082s1-9.1-7.138-9.1-7.807 8.434-7.807 8.434V67h-13.2V24.269h12.69v6.3c1.439-3.519 6-8.533 17.684-6.792C67.9 25.538 66.983 42.686 66.983 42.686Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgLinkedin;